import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showFields: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.dropdown-menu.show-fields',
		defaultMessage: 'Show fields',
		description: 'Label for show fields menu item in issue-create modal header',
	},
	findField: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.dropdown-menu.find-field',
		defaultMessage: 'Find your field',
		description: 'Label for find field menu item in issue-create modal header',
	},
});
